import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import NavHeader from '../../common/NavHeader/NavHeader';
import SectionHeader from '../../common/typography/SectionHeader';
import CustomContainer from '../../common/wrapper/Container';
import VerticalStack from '../../common/wrapper/VerticalStack';
import CustomeHeading from '../../customeHeading/customeHeading';
import {
    GetClinicAvailableDateAction,
    GetAvailableTimeSlotsAction,
} from '../../redux/actions/dateTimeslots/DateTimeSlots';
import { GetNextAvailableDateForBookingsAction } from '../../redux/actions/getNextAvailableDateForBookings/GetNextAvailableDateForBookings';
import { CLEAR_TIME_SLOTS } from '../../redux/constants/dateTimeslots/DateTimeSlots';
import CustomCalendar from '../dateTime/steps/CustomCalendar';
import { BOOKING_LINK_STEP } from './constants';
import Skeleton from 'react-loading-skeleton';
import EventTimeSlots from '../dateTime/EventTimeSlots/EventTimeSlots';
import NoDataFallback from '../../common/no-data-fallback/NoDataFallback';
import { ReactComponent as RainIcon } from '../../../images/icons/rain-icon-bl.svg';
import { CustomCalendarSkeleton } from '../../clininc-cart-skeleton/calenadar-skeleton/CustomCalendarSkeleton';
import { APP_COMPONENT_SIZE } from '../../../utils/constants';

const TimeSlotSkeleton = () => {
    return (
        <>
            <div className="time-slot-wrapper">
                {[...Array(3)].map((item, index) => {
                    return (
                        <div className="event-wrapper">
                            <Skeleton width={90} height={24} />
                            <div className="events-slots">
                                {[...Array(12)].map((item, index) => {
                                    return <Skeleton width={56} height={29} borderRadius={100} />;
                                })}
                            </div>
                        </div>
                    );
                })}
            </div>
        </>
    );
};

function SelectDateTime({
    setStep,
    showSelectedDate,
    setShowSelectedDate,
    showSelectedTime,
    setShowSelectedTime,
    setFormatedDate,
    clinicId,
    selectedTreatment,
    resetData,
}) {
    const [selectedDate, setSelectedDate] = useState(new Date());
    // State to store the selected month and year from the calendar
    const [selectedMonth, setSelectedMonth] = useState(selectedDate.getMonth() + 1);
    const [selectedYear, setSelectedYear] = useState(selectedDate.getFullYear());
    const [startDate, setStartDate] = useState(moment().format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState(null);

    const [isOpenCalendar, setIsOpenCalendar] = useState(false); //for mobile
    const dispatch = useDispatch();
    const { clinicsAvailableDateData, initClinicsAvailableDateResponseFunction } =
        GetClinicAvailableDateAction();
    const { availableTimeSlotData, initAvalableTimeSlotData } = GetAvailableTimeSlotsAction();
    const { getNextAvailableDateForBookingsData, initGetNextAvailableDateForBookings } =
        GetNextAvailableDateForBookingsAction();

    const [noTimeSlots, setNoTimeSlots] = useState(false);
    const [clinicNotAvailable, setClinicNotAvailable] = useState(false);

    const timeslots = useSelector((state) => state?.GetDateTimeSlotsReducer?.timeslots);

    // if pagination is required then uncomment the below code
    // const totalTimeSlotsCount = useSelector(
    //     (state) => state?.GetDateTimeSlotsReducer?.totalTimeSlotsCount
    // );
    // const timeSlotsPage = useSelector((state) => state?.GetDateTimeSlotsReducer?.timeSlotsPage);
    // const loadedTimeSlotsCount = useSelector(
    //     (state) => state?.GetDateTimeSlotsReducer?.loadedTimeSlotsCount
    // );

    const initiateAvailableTimeSlotListCall = (refreshList = false) => {
        // if pagination is required then uncomment the below code
        // let newPage = timeSlotsPage + 1;
        // if (refreshList) {
        //     newPage = 1;
        // } else if (totalTimeSlotsCount <= loadedTimeSlotsCount) {
        //     return;
        // }

        initAvalableTimeSlotData(
            {
                clinicId: clinicId,
                date: moment(showSelectedDate, 'dddd, Do MMMM YYYY').format('YYYY-MM-DD'),
                treatmentIds: selectedTreatment.map((item) => item.id),
                page: -1,
                // limit: 15,
                removePastSlots: true,
            },
            (data) => {
                if (data?.items?.length === 0) {
                    setNoTimeSlots(true);
                } else {
                    setNoTimeSlots(false);
                }
            }
        );
    };

    useEffect(() => {
        dispatch({
            type: CLEAR_TIME_SLOTS,
        });
        setNoTimeSlots(false);
        if (showSelectedDate && !clinicNotAvailable) {
            initiateAvailableTimeSlotListCall(true);
        }
    }, [showSelectedDate]);

    const handleSelectedDate = (selectedDate) => {
        dispatch({
            type: CLEAR_TIME_SLOTS,
        });

        setShowSelectedDate(selectedDate);
    };

    useEffect(() => {
        if (showSelectedDate) {
            setSelectedYear(moment(showSelectedDate, 'dddd, Do MMMM YYYY').format('YYYY'));
            setSelectedMonth(moment(showSelectedDate, 'dddd, Do MMMM YYYY').format('MM'));
        }
    }, [showSelectedDate]);
    useEffect(() => {
        if (endDate) {
            if (moment(startDate).format('YYYY-MM') == moment().format('YYYY-MM')) {
                initClinicsAvailableDateResponseFunction({
                    clinicId: clinicId,
                    startDate: moment().format('YYYY-MM-DD'),
                    endDate: endDate,
                });
            } else {
                initClinicsAvailableDateResponseFunction({
                    clinicId: clinicId,
                    startDate: startDate,
                    endDate: endDate,
                });
            }
        }
    }, [startDate, endDate]);

    useEffect(() => {
        if (clinicId) {
            initGetNextAvailableDateForBookings({
                clinicId: clinicId,
                tokenSug: '',
            });
        }
    }, [clinicId]);

    useEffect(() => {
        if (showSelectedDate && showSelectedTime) {
            return;
        }

        const availableData =
            getNextAvailableDateForBookingsData?.data?.getNextAvailableDateForBookings;
        if (!availableData) {
            return;
        }

        setSelectedMonth(moment(availableData?.data?.date).format('MM'));
        setSelectedYear(moment(availableData?.data?.date).format('YYYY'));
        setShowSelectedDate(moment(availableData?.data?.date).format('dddd, Do MMMM YYYY'));
        setFormatedDate(moment(availableData?.data?.date).format('Do MMMM YYYY'));
    }, [getNextAvailableDateForBookingsData]);

    return (
        <CustomContainer removeTopPadding>
            <VerticalStack className='mb-1' space={15}>
                <NavHeader
                    isSticky
                    isBackOnly
                    handleOnBack={() => setStep(BOOKING_LINK_STEP.TREATMENT)}
                />
                <CustomeHeading
                    Title="When are you free?"
                    Desc="Choose an available date and time for your appointment."
                />
            </VerticalStack>
            <VerticalStack space={20}>
                <SectionHeader size={APP_COMPONENT_SIZE.medium} title="Select date" />
                {clinicsAvailableDateData?.loading ? (
                    <CustomCalendarSkeleton small />
                ) : (
                    <CustomCalendar
                        setShowSelectedDate={(date) => {
                            resetData();
                            setShowSelectedDate(date);
                        }}
                        setStartDate={setStartDate}
                        setEndDate={setEndDate}
                        selectedMonth={selectedMonth}
                        selectedYear={selectedYear}
                        setSelectedMonth={setSelectedMonth}
                        setSelectedYear={setSelectedYear}
                        showSelectedDate={showSelectedDate}
                        onSelectDate={handleSelectedDate}
                        setFormatedDate={setFormatedDate}
                        setShowSelectedTime={setShowSelectedTime}
                        dateData={
                            clinicsAvailableDateData?.data?.getClinicAvailableDates?.data?.items
                                ?.length > 0
                                ? clinicsAvailableDateData?.data?.getClinicAvailableDates?.data
                                      ?.items
                                : []
                        }
                        setIsOpenMobileCalendar={setIsOpenCalendar}
                        isShowMobileButton={false}
                        onUnavailabilityChange={(state) => setClinicNotAvailable(state)}
                    />
                )}

                <SectionHeader size={APP_COMPONENT_SIZE.medium} title="Select time" />

                {availableTimeSlotData?.loading && <TimeSlotSkeleton />}
                {noTimeSlots && <NoDataFallback icon={<RainIcon />} text="No time slots found" />}
                {clinicNotAvailable && (
                    <NoDataFallback
                        icon={<RainIcon />}
                        text="No time slots are available"
                    />
                )}
                {timeslots?.length > 0 && (
                    <EventTimeSlots
                        timeslots={timeslots}
                        showSelectedTime={showSelectedTime}
                        setShowSelectedTime={(time) => {
                            setShowSelectedTime(time);
                            resetData();
                        }}
                    />
                )}
            </VerticalStack>
        </CustomContainer>
    );
}
export default SelectDateTime;
